import { useTranslation } from 'react-i18next'

import { GamConnectionOrderStatus } from 'features/workspace/types/gamConnectionOrderStatus'
import SignalConnected from 'images/icons/signal-connected.svg?react'
import SignalDisconnected from 'images/icons/signal-disconnected.svg?react'
import { KNOWLEDGE_BASE } from '../../constants'
import { UseConfig } from './types'

export const useConfig = (status: GamConnectionOrderStatus): UseConfig => {
  const { t: tC } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.connectionStatus',
  })

  switch (status) {
    case 'completed':
      return {
        color: 'success.main',
        icon: SignalConnected,
      }
    case 'failed':
      return {
        color: 'error.main',
        icon: SignalDisconnected,
        tooltip: {
          content: t('tooltip'),
          link: {
            title: tC('learnMore'),
            url: KNOWLEDGE_BASE,
          },
        },
      }
    case 'inProgress':
      return {
        color: 'warning.main',
      }
  }
}
